<script>
  import OSUNavbar from './OSUNavbar.svelte';
  import Navbar from './Navbar.svelte';
  import Menu from './Menu.svelte';
  import AboutGuidelines from './menus/AboutGuidelines.svelte';
  import VisitUs from './menus/VisitUs.svelte';
  import Policy from './menus/Policy.svelte';
  import Tutorials from './menus/Tutorials.svelte';
  import Education from './menus/Education.svelte';
  import PotentialProjects from './menus/PotentialProjects.svelte';
  import OtherFacilities from './menus/OtherFacilities.svelte';
  import Publications from './menus/Publications.svelte';
  import AlertMessage from './AlertMessage.svelte';
  import Squares from './Squares.svelte';
  import FeaturedPublications from './FeaturedPublications.svelte';
  import Footer from './Footer.svelte';
  // Find new icons from: https://carbon-icons-svelte.onrender.com/
  import Building32 from "carbon-icons-svelte/lib/Building32";
  import Notebook32 from "carbon-icons-svelte/lib/Notebook32";
  import Play32 from "carbon-icons-svelte/lib/Play32";
  import Education32 from "carbon-icons-svelte/lib/Education32";
  import Plane32 from "carbon-icons-svelte/lib/Plane32";
  import Information32 from "carbon-icons-svelte/lib/Information32";
  import Pen32 from "carbon-icons-svelte/lib/Pen32";

  let openedMenu = null;
  const menus = [
    { name: 'About & Guidelines', icon: Information32 },
	{ name: 'Potential Projects', icon: Pen32 },
	{ name: 'Tutorials', icon: Play32 },
	{ name: 'Visit Us', icon: Plane32 },
    { name: 'Education', icon: Education32 },
    { name: 'Other Facilities', icon: Building32 },
	{ name: 'Publications', icon: Pen32 }
  ];
</script>

<svelte:head>
	<title>Polar Rock Repository Database</title>

	<!-- Google tag (gtag.js) -->
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-Q29Q4PLC75"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', 'G-Q29Q4PLC75');
	</script>
</svelte:head>

<!-- 
	Thanks to Michael Zhan for navbar and side-menu code!
--> 
<Navbar
  {menus}
  bind:openedMenu
/>
<Menu bind:openedMenu menuName="About & Guidelines">
  <AboutGuidelines
	bind:openedMenu
	/>
  </Menu>
<Menu bind:openedMenu menuName="Policy">
  <Policy />
  </Menu>
<Menu bind:openedMenu menuName="Visit Us">
  <VisitUs />
  </Menu>
<Menu bind:openedMenu menuName="Tutorials">
  <Tutorials />
  </Menu>
<Menu bind:openedMenu menuName="Education">
  <Education />
  </Menu>
<Menu bind:openedMenu menuName="Potential Projects">
  <PotentialProjects />
  </Menu>
<Menu bind:openedMenu menuName="Other Facilities">
  <OtherFacilities />
  </Menu>
<Menu bind:openedMenu menuName="Publications">
	<Publications />
	</Menu>

<main>
	
	<OSUNavbar /> 
	<AlertMessage />
	<div>
		<h1>
			The Polar Rock Repository Database
		</h1>
		Providing terrestrial samples, dredges, images, and data for research and education
	</div>
	<Squares />
	<FeaturedPublications />
	<Footer />
</main>


<style>
  :global(body) {
  	display: flex;
  	flex-direction: row;
  	position: relative;
  }

  main {
  	flex: 1;
  	display: flex;
  	flex-direction: column;
  	line-height: 1.22;
  	font-size: 13pt;
  	font-weight: 400;
  	font-family: Verdana, Arial, Helvetica, sans-serif;
  	color: #000;
  	background-image: url("../images/background.jpg");
  	background-size: 1500px 100%;
  }

  div {
  	margin: 0px;
  	text-align: center;
  	font-size: 13pt;
  	font-weight: 400;
  	line-height: 1;
	font-family: 'proximanova', 'Source Sans Pro', sans-serif;
  }

  h1 {
  	font-size: 30pt;
	font-weight: 700;
	line-height: 0.94;
	margin-top: 20px;
	margin-bottom: 10px;
  }

  @media (orientation: portrait) {
  	main {
  	  flex-direction: column;
  	  background-repeat: repeat;
	}

	h1 {
	  	font-size: 16pt;
	  	font-weight: 600;
	  }
  }
</style>
